var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.formType == "detail" ? _vm.$t("ckxq") : _vm.$t("bjjyls"),
        visible: _vm.visible,
        width: "600px",
      },
      on: {
        close: function ($event) {
          return _vm.resetForm("user")
        },
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "user",
          staticClass: "demo-ruleForm",
          staticStyle: { "max-height": "400px", "overflow-y": "scroll" },
          attrs: { model: _vm.formValidate, "label-width": "100px" },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("ddbh"), prop: "order_sn" } },
            [
              _c("el-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.formValidate.order_sn,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "order_sn", $$v)
                  },
                  expression: "formValidate.order_sn",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("yhzh"), prop: "account" } },
            [
              _c("el-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.formValidate.account,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "account", $$v)
                  },
                  expression: "formValidate.account",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("yongName"), prop: "nickname" } },
            [
              _c("el-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.formValidate.nickname,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "nickname", $$v)
                  },
                  expression: "formValidate.nickname",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("cpmc"), prop: "product_id" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { filterable: "", disabled: _vm.formType == "detail" },
                  model: {
                    value: _vm.formValidate.product_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.formValidate, "product_id", $$v)
                    },
                    expression: "formValidate.product_id",
                  },
                },
                _vm._l(_vm.productList, function (item, index) {
                  return _c("el-option", {
                    key: index,
                    attrs: { label: item.product_name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("gmfx"), prop: "type" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { disabled: _vm.formType == "detail" },
                  model: {
                    value: _vm.formValidate.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.formValidate, "type", $$v)
                    },
                    expression: "formValidate.type",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.$t("maizhang"), value: 1 },
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: _vm.$t("maidie"), value: 2 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("jcdw"), prop: "jcdw" } },
            [
              _c("el-input", {
                attrs: { disabled: _vm.formType == "detail" },
                model: {
                  value: _vm.formValidate.jcdw,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "jcdw", $$v)
                  },
                  expression: "formValidate.jcdw",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("ddsj"), prop: "time" } },
            [
              _c("el-input", {
                attrs: { disabled: _vm.formType == "detail" },
                model: {
                  value: _vm.formValidate.time,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "time", $$v)
                  },
                  expression: "formValidate.time",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("pcdw"), prop: "pcdw" } },
            [
              _c("el-input", {
                attrs: { disabled: _vm.formType == "detail" },
                model: {
                  value: _vm.formValidate.pcdw,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "pcdw", $$v)
                  },
                  expression: "formValidate.pcdw",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("wtye"), prop: "wtye" } },
            [
              _c("el-input", {
                attrs: { disabled: _vm.formType == "detail" },
                model: {
                  value: _vm.formValidate.wtye,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "wtye", $$v)
                  },
                  expression: "formValidate.wtye",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("xdsxf"), prop: "wxwtye" } },
            [
              _c("el-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.formValidate.wxwtye,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "wxwtye", $$v)
                  },
                  expression: "formValidate.wxwtye",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("yxwtye"), prop: "yxwtye" } },
            [
              _c("el-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.formValidate.yxwtye,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "yxwtye", $$v)
                  },
                  expression: "formValidate.yxwtye",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("mhye"), prop: "mhye" } },
            [
              _c("el-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.formValidate.mhye,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "mhye", $$v)
                  },
                  expression: "formValidate.mhye",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("user")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("calcelText")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.formType == "edit",
                  expression: "formType == 'edit'",
                },
              ],
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("formValidate")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("trueText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }